import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../../../consts/api";

export const useTimeTrackingConfigs = (options = {}) => {
  const res = useQuery(
    [QUERY_KEYS.timeclockSettings.getTimeTrackingConfigs],
    () => http.get(HTTP_ENDPOINTS.timeclockSettings.getTimeTrackingConfigs()),
    { cacheTime: 0, select: (data) => data.data.data, ...options },
  );
  return res;
};
